import Snackbar from './Snackbar'

export default {
  Snackbar
}



// WEBPACK FOOTER //
// ./src/components/snackbars/index.js